import { Chrono } from 'react-chrono'
import TimelineCard from '../TimeLineCard'
import styled from 'styled-components'
import ThemeContext from '../../context/ThemeContext'

const Container = styled.section`
  padding: 40px 0px;
  background-image: transparent;
  min-height: 100vh;
  color: #ffffff;
  margin-top: 30px;

`

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
`

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;

  span {
    color: #ffdd95;
  }
`

const Subtitle = styled.p`
  font-size: 1.125rem;
  color: #e0cfff;
`

const ChronoWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`
const timelineItemsList = [
    {
        id: '1',
        title: '2022-2026',
        courseTitle: 'Nxtwave CCBP 4.0 Academy Genius Course',
        at: "Nxtwave",
        description:
            'Learnt complete FullStack Development, Advanced DSA and Make myself ready for 4.0 Industry.',
        duration: '4 years',
        website: 'https://www.ccbp.in/',
        tagsList: [
            {
                id: '1',
                name: 'React',
            },
            {
                id: '2',
                name: 'Node.js',
            },
            {
                id: '3',
                name: 'MongoDb',
            },
            {
                id: '4',
                name: 'SQLite',
            },
            {
                id: '5',
                name: 'HTML',
            },
            {
                id: '6',
                name: 'CSS',
            },
            {
                id: '7',
                name: 'Python',
            },
            {
                id: '8',
                name: 'Advanced DSA',
            },
            {
                id: '9',
                name: 'Growth Mindset',
            },
        ],
    }, {
        id: '2',
        title: '2022-2026',
        courseTitle: 'Bachelor of Technology',
        at: "Vellore Institute of technology, Amaravati",
        website: "https://vitap.ac.in/",
        description:
            'Completed B.Tech in Computer Science and Engineering with specialization in Cybersecurity.',
        duration: '4 years',
        tagsList: [
            {
                id: '1',
                name: 'Computer Networks',
            },
            {
                id: '2',
                name: 'DBMS',
            },
            {
                id: '3',
                name: 'Operating Systems',
            },
            {
                id: '4',
                name: 'DAA',
            },
            {
                id: '5',
                name: 'OOPS in Java',
            },
            {
                id: '6',
                name: 'Public speaking',
            },
            {
                id: '7',
                name: 'Problem Solving',
            },
        ],
    },
    {
        id: '3',
        title: '2020-2022',
        courseTitle: 'Intermediate',
        at: "Sasi Junior College, Tanuku",
        website: "https://www.sasi.edu.in/",
        description:
            'Completed my Intermediate in Andhra Pradesh Board of Intermediate Education in MPC with marks 976/1000',
        duration: '2 years',
        tagsList: [
            {
                id: '1',
                name: 'Mathematics',
            },
            {
                id: '2',
                name: 'Physics',
            },
            {
                id: '3',
                name: 'Chemistry',
            },
            {
                id: '4',
                name: 'Time Management',
            },
            {
                id: '5',
                name: 'Effective Listening',
            },
            {
                id: '6',
                name: 'Effective Writing',
            }
        ],
    },
    {
        id: '4',
        title: '2019-2020',
        courseTitle: 'Secondary Education',
        at: "Sasi Educational Institutions, Tanuku",
        website: "https://www.sasi.edu.in/",
        description:
            'Completed my Intermediate in Andhra Pradesh Board of Secondary Education with 100% marks.',
        duration: '1 year',
        tagsList: [
            {
                id: '1',
                name: 'Mathematics',
            },
            {
                id: '2',
                name: 'Physics',
            },
            {
                id: '3',
                name: 'Chemistry',
            },
            {
                id: '4',
                name: 'Time Management',
            },
            {
                id: '5',
                name: 'Effective Listening',
            },
            {
                id: '6',
                name: 'Effective Writing',
            }
        ],
    },

]
const Journey = () => (
    <ThemeContext.Consumer>
        {value => (
            <Container>
                <Header>
                    <Title>
                        My <span>Education Journey</span>
                    </Title>
                    <Subtitle>A timeline of Educational growth</Subtitle>
                </Header>

                <ChronoWrapper>
                    <Chrono
                        mode="VERTICAL"
                        items={timelineItemsList}
                        cardHeight={220}
                        highlightCardsOnHover
                        disableToolbar
                        toolbarPosition='bottom'
                        theme={{
                            primary: '#ffdd95',
                            secondary: '#e0cfff',
                            cardBgColor: value.theme==='light'?'#fff0fa':'#1e1b2e',
                            titleColor: '#FFFFFF',
                            titleColorActive: '#000000',
                        }}
                    >
                        {timelineItemsList.map(item => (
                            <TimelineCard key={item.id} details={item} />
                        ))}
                    </Chrono>
                </ChronoWrapper>
            </Container>)}
    </ThemeContext.Consumer>

)

export default Journey
